module.exports = __webpack_public_path__ + "static/media/icon_pen.d49eec06.svg";